export const IMAGE_TYPES = [
    'image/png',
    'image/jpeg',
    'image/jpg',
    'image/gif',
    'image/svg+xml',
];


// video
export const SAFE_VIDEO_TYPES = ['video/mp4'];

export const UNSAFE_VIDEO_TYPES = [
    'video/x-flv', // flv
    'flv-application/octet-stream', // rmvb
    'video/avi', // avi
    'video/x-msvideo', // avi
    'video/quicktime', // mov
    // 'video/3gpp',
    // 'audio/x-pn-realaudio',
    // 'video/x-matroska',
];

export const VIDEO_TYPES = [...SAFE_VIDEO_TYPES, ...UNSAFE_VIDEO_TYPES];

// audio
export const SAFE_AUDIO_TYPES = ['audio/mpeg', 'audio/mp3'];

export const UNSAFE_AUDIO_TYPES = [];

export const AUDIO_TYPES = [...SAFE_AUDIO_TYPES, ...UNSAFE_AUDIO_TYPES];


export const EXT_TO_MIME_MAP = {
    // 图片
    'jpg': 'image/jpeg',
    'jpeg': 'image/jpeg',
    'png': 'image/png',
    'gif': 'image/gif',
    'svg': 'image/svg+xml',
    // 视频
    'mp4': 'video/mp4',
    'flv': 'video/x-flv',
    'avi': 'video/avi',
    'mov': 'video/quicktime',
    '3gp': 'video/3gpp',
    'rmvb': 'audio/x-pn-realaudio',
    'mkv': 'video/x-matroska',
    // 音频
    'mp3': 'audio/mpeg',
};

export const MIME_TO_EXT_MAP = {
    // 图片
    'image/jpeg': 'jpg',
    'image/jpg': 'jpg',
    'image/png': 'png',
    'image/gif': 'gif',
    'image/svg+xml': 'svg',
    // 视频
    'video/mp4': 'mp4',
    'video/x-flv': 'flv',
    'flv-application/octet-stream': 'flv',
    'video/x-msvideo': 'avi',
    'video/avi': 'avi',
    'video/quicktime': 'mov',
    'video/3gpp': '3gp',
    'audio/x-pn-realaudio': 'rmvb',
    'video/x-matroska': 'mkv',
    // 音频
    'audio/mpeg': 'mp3',
    'audio/mp3': 'mp3', // @TODO 移除这个, 规范里没有这个格式
};

export const MAX_IMAGE_SIZE = 12 * 1024 * 1024;
export const MAX_VIDEO_SIZE = 50 * 1024 * 1024;

export const IMAGE_FORMATS = ['jpg', 'jpeg', 'png', 'jfif'];
export const VIDEO_FORMATS = ['mp4', 'avi', 'mov', 'flv'];
export const AUDIO_FORMATS = ['mp3'];
export const SAFE_VIDEO_FORMATS = ['mp4'];
